import MindrailLogo from "./MindrailLogo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="px-6 lg:px-10 pb-12 pt-8 border-t border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="leading-tight">
          <MindrailLogo size={52} />
          <p className="text-xs text-[#475569] mt-2">
            A private ADHD work companion · local-first
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#475569]">
          <a href="#how" className="hover:text-[#0F172A]" data-testid="footer-how">
            How it works
          </a>
          <a
            href="#features"
            className="hover:text-[#0F172A]"
            data-testid="footer-features"
          >
            Features
          </a>
          <a href="#pricing" className="hover:text-[#0F172A]" data-testid="footer-pricing">
            Pricing
          </a>
          <a
            href="/privacy"
            className="hover:text-[#0F172A]"
            data-testid="footer-privacy"
          >
            Privacy Policy
          </a>
          <a
            href="mailto:support@mindrail.co"
            className="hover:text-[#0F172A]"
            data-testid="footer-contact"
          >
            Contact
          </a>
        </nav>

        <p className="text-xs text-[#475569] font-mono">
          © {new Date().getFullYear()} Mindrail · made for the brain you have today
        </p>
      </div>
    </footer>
  );
}
